import TtamBudgetCboInfo from './cbo-info/index.vue';
import TtamBudgetSplittestLabelHint from './splittest-label-hint/index.vue';
import TtamBudgetSplittestLabel from './splittest-label/index.vue';
import TtamBudgetLabel from './label/index.vue';
import TtamBudgetTips from './tips/index.vue';
import TtamDynamicDailyBudgetTip from './dynamic-daily-budget-tip/index.vue';

import TtamBudgetLearningPhaseTips from './learning-phase-tips/index.vue';
import TtamBudgetSet from './set/index.vue';
import TtamBudgetRecommend from './recommend/index.vue';
import TtamBudgetScheduledBudget from './scheduled-budget/index.vue';
import TtamBudgetCoupon from './coupon/index.vue';
import * as hooks from './hooks';

export default {
  TtamBudgetSet,
  TtamBudgetTips,
  TtamBudgetLearningPhaseTips,
  TtamBudgetCboInfo,
  TtamBudgetSplittestLabelHint,
  TtamBudgetSplittestLabel,
  TtamBudgetLabel,
  TtamBudgetRecommend,
  TtamBudgetScheduledBudget,
  TtamDynamicDailyBudgetTip,
  TtamBudgetCoupon,
  ...hooks,
};
